import { restApi } from 'apis'
import { PromoCode } from 'models'

const promoCodeApi = restApi.injectEndpoints({
  endpoints: (builder) => ({
    getPromoCodeByName: builder.query<PromoCode, { storeId: string; name: string }>(
      {
        query: ({ storeId, name }) => ({
          url: `/promocode/${storeId}/name/${name}`,
        }),
      },
    ),
  }),
})

export const { useGetPromoCodeByNameQuery, useLazyGetPromoCodeByNameQuery } =
  promoCodeApi
